import { Button } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import type { AdviceSummaryCtaProps } from "../../types";

export function AdviceSummaryCta({
  hasTransfers,
  hasFundSwitches,
}: AdviceSummaryCtaProps) {
  if (hasTransfers) {
    return (
      <Button
        component={Link}
        to="/transfer-terms"
        data-testid="advice-summary-cta"
      >
        <FormattedMessage
          id="bottomNav.seeTransferTerms"
          defaultMessage="Flyttvillkor"
        />
      </Button>
    );
  }

  if (hasFundSwitches) {
    return (
      <Button component={Link} to="/dashboard" data-testid="advice-summary-cta">
        <FormattedMessage id="bottomNav.next" defaultMessage="Nästa" />
      </Button>
    );
  }

  return (
    <Button disabled data-testid="advice-summary-cta">
      <FormattedMessage
        id="bottomNav.seeTransferTerms"
        defaultMessage="Flyttvillkor"
      />
    </Button>
  );
}
